
import { HolidayBackground, holidayBackgrounds } from './holidayBackgrounds';

const defaultBackground: HolidayBackground = {
    name: 'Default',
    startDate: '01-01',
    endDate: '12-31',
    backgroundGif: './assets/images/holiday-season-bg.gif', // <-- Add this file to your public/images folder
    snowfall: false,
};

export const getCurrentHolidayBackground = (): HolidayBackground | null => {
    const today = new Date();
    const current = `${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    for (let holiday of holidayBackgrounds) {
        const start = holiday.startDate;
        const end = holiday.endDate;
        if (
            (start <= current && current <= end) ||
            (start > end && (current >= start || current <= end)) // Spans year boundary
        ) {
            return holiday;
        }
    }
    return defaultBackground;// No matching holiday
};
